import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/reports/create')({
  beforeLoad: () => getTitleContextSlice('Create Report'),
  staticData: {
    owner: CodeOwner.Analytics,
  },
});
